import React from 'react'
import Header from '../../View/Header'
import Footer from '../../View/Footer'
import AboutView from '../../View/AboutUs'
function index() {
return (
<>
   <Header />
   <AboutView />  
   <Footer/>
</>
)
}
export default index